var _filter, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _use, _use2, _use3, _use4, _use5, _use6, _use7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "52px",
    height: "72px",
    viewBox: "0 0 52 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 52,
    height: 72,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.976471,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 52,
    height: 72
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 39.882812 19.757812 C 39.882812 21.269531 39.882812 22.78125 39.882812 24.292969 C 39.851562 24.292969 39.820312 24.292969 39.789062 24.292969 C 39.789062 22.78125 39.789062 21.269531 39.789062 19.757812 C 39.046875 19.757812 38.304688 19.757812 37.5625 19.757812 C 37.5625 18.988281 37.5625 18.214844 37.5625 17.445312 C 36.042969 17.445312 34.527344 17.445312 33.011719 17.445312 C 33.011719 18.214844 33.011719 18.988281 33.011719 19.757812 C 32.269531 19.757812 31.523438 19.757812 30.78125 19.757812 C 30.78125 21.269531 30.78125 22.78125 30.78125 24.292969 C 30.007812 24.292969 29.234375 24.292969 28.460938 24.292969 C 28.460938 25.035156 28.460938 25.773438 28.460938 26.515625 C 27.71875 26.515625 26.976562 26.515625 26.230469 26.515625 C 26.203125 26.515625 26.171875 26.515625 26.140625 26.515625 C 26.140625 25.742188 26.140625 24.972656 26.140625 24.199219 C 26.914062 24.199219 27.6875 24.199219 28.460938 24.199219 C 28.460938 22.71875 28.460938 21.238281 28.460938 19.757812 C 29.203125 19.757812 29.945312 19.757812 30.6875 19.757812 C 30.6875 13.710938 30.6875 7.664062 30.6875 1.621094 C 33.753906 1.621094 36.816406 1.621094 39.882812 1.621094 C 39.882812 7.664062 39.882812 13.710938 39.882812 19.757812 Z M 39.882812 19.757812 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 52,
    height: 72,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.980392,
      stroke: "none"
    }
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 52,
    height: 72
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 39.882812 19.757812 C 40.625 19.757812 41.367188 19.757812 42.109375 19.757812 C 42.109375 21.238281 42.109375 22.71875 42.109375 24.199219 C 42.882812 24.199219 43.660156 24.199219 44.433594 24.199219 C 44.433594 24.972656 44.433594 25.742188 44.433594 26.515625 C 45.175781 26.515625 45.917969 26.515625 46.660156 26.515625 C 46.660156 28.027344 46.660156 29.539062 46.660156 31.050781 C 45.886719 31.050781 45.113281 31.050781 44.339844 31.050781 C 44.339844 29.539062 44.339844 28.027344 44.339844 26.515625 C 43.597656 26.515625 42.855469 26.515625 42.109375 26.515625 C 42.109375 25.773438 42.109375 25.035156 42.109375 24.292969 C 41.367188 24.292969 40.625 24.292969 39.882812 24.292969 C 39.882812 22.78125 39.882812 21.269531 39.882812 19.757812 Z M 39.882812 19.757812 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 52,
    height: 72,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.988235,
      stroke: "none"
    }
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 52,
    height: 72
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface11",
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(1.568627%,1.568627%,1.568627%)",
      fillOpacity: 1
    },
    d: "M 26.140625 26.515625 C 26.171875 26.515625 26.203125 26.515625 26.230469 26.515625 C 26.230469 26.546875 26.230469 26.574219 26.230469 26.605469 C 26.230469 27.347656 26.230469 28.085938 26.230469 28.828125 C 26.230469 29.566406 26.230469 30.308594 26.230469 31.050781 C 25.488281 31.050781 24.746094 31.050781 24.003906 31.050781 C 24.035156 30.292969 24.003906 29.550781 23.910156 28.828125 C 18.648438 28.828125 13.386719 28.828125 8.125 28.828125 C 8.125 29.566406 8.125 30.308594 8.125 31.050781 C 7.382812 31.050781 6.640625 31.050781 5.894531 31.050781 C 5.867188 31.050781 5.835938 31.050781 5.804688 31.050781 C 5.804688 29.539062 5.804688 28.027344 5.804688 26.515625 C 12.582031 26.515625 19.359375 26.515625 26.140625 26.515625 Z M 26.140625 26.515625 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 52,
    height: 72,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.968627,
      stroke: "none"
    }
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 52,
    height: 72
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface14",
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 5.804688 31.050781 C 5.804688 33.300781 5.804688 35.550781 5.804688 37.804688 C 5.03125 37.804688 4.257812 37.804688 3.480469 37.804688 C 3.480469 35.550781 3.480469 33.300781 3.480469 31.050781 C 4.257812 31.050781 5.03125 31.050781 5.804688 31.050781 Z M 5.804688 31.050781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 52,
    height: 72,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.980392,
      stroke: "none"
    }
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 52,
    height: 72
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface17",
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 46.660156 31.050781 C 47.433594 31.050781 48.207031 31.050781 48.980469 31.050781 C 48.980469 43.882812 48.980469 56.714844 48.980469 69.546875 C 48.207031 69.546875 47.433594 69.546875 46.660156 69.546875 C 46.660156 70.289062 46.660156 71.027344 46.660156 71.769531 C 33.042969 71.769531 19.421875 71.769531 5.804688 71.769531 C 5.804688 70.226562 5.804688 68.683594 5.804688 67.140625 C 6.546875 67.140625 7.289062 67.140625 8.03125 67.140625 C 8.03125 66.402344 8.03125 65.660156 8.03125 64.921875 C 9.546875 64.921875 11.066406 64.921875 12.582031 64.921875 C 12.582031 61.1875 12.582031 57.453125 12.582031 53.722656 C 10.324219 53.722656 8.0625 53.722656 5.804688 53.722656 C 5.804688 52.953125 5.804688 52.179688 5.804688 51.410156 C 8.835938 51.410156 11.871094 51.410156 14.902344 51.410156 C 14.902344 52.148438 14.902344 52.890625 14.902344 53.628906 C 14.902344 55.914062 14.902344 58.195312 14.902344 60.476562 C 14.902344 62.730469 14.902344 64.980469 14.902344 67.234375 C 14.160156 67.234375 13.417969 67.234375 12.675781 67.234375 C 11.902344 67.234375 11.128906 67.234375 10.355469 67.234375 C 9.609375 67.234375 8.867188 67.234375 8.125 67.234375 C 8.125 67.972656 8.125 68.714844 8.125 69.453125 C 8.867188 69.453125 9.609375 69.453125 10.355469 69.453125 C 11.128906 69.453125 11.902344 69.453125 12.675781 69.453125 C 14.933594 69.453125 17.195312 69.453125 19.453125 69.453125 C 20.195312 69.453125 20.9375 69.453125 21.683594 69.453125 C 22.457031 69.453125 23.230469 69.453125 24.003906 69.453125 C 24.003906 68.714844 24.003906 67.972656 24.003906 67.234375 C 21.761719 67.140625 19.5 67.109375 17.226562 67.140625 C 17.226562 61.898438 17.226562 56.652344 17.226562 51.410156 C 20.226562 51.410156 23.230469 51.410156 26.230469 51.410156 C 26.230469 52.890625 26.230469 54.371094 26.230469 55.851562 C 26.230469 55.882812 26.230469 55.914062 26.230469 55.945312 C 26.230469 60.449219 26.230469 64.949219 26.230469 69.453125 C 33.011719 69.453125 39.789062 69.453125 46.566406 69.453125 C 46.660156 56.667969 46.691406 43.867188 46.660156 31.050781 Z M 19.453125 53.722656 C 20.9375 53.722656 22.425781 53.722656 23.910156 53.722656 C 23.910156 57.453125 23.910156 61.1875 23.910156 64.921875 C 22.425781 64.921875 20.9375 64.921875 19.453125 64.921875 C 19.453125 61.1875 19.453125 57.453125 19.453125 53.722656 Z M 19.453125 53.722656 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 52,
    height: 72,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.984314,
      stroke: "none"
    }
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 52,
    height: 72
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface20",
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 3.480469 37.804688 C 3.480469 41.597656 3.480469 45.394531 3.480469 49.1875 C 2.738281 49.1875 1.996094 49.1875 1.253906 49.1875 C 1.253906 45.394531 1.253906 41.597656 1.253906 37.804688 C 1.996094 37.804688 2.738281 37.804688 3.480469 37.804688 Z M 3.480469 37.804688 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 52,
    height: 72,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.968627,
      stroke: "none"
    }
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 52,
    height: 72
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface23",
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 3.480469 49.1875 C 4.257812 49.1875 5.03125 49.1875 5.804688 49.1875 C 5.804688 49.929688 5.804688 50.667969 5.804688 51.410156 C 5.03125 51.410156 4.257812 51.410156 3.480469 51.410156 C 3.480469 50.667969 3.480469 49.929688 3.480469 49.1875 Z M 3.480469 49.1875 "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(67.843137%,7.058824%,4.313725%)",
      fillOpacity: 1
    },
    d: "M 37.5625 6.246094 C 36.042969 6.246094 34.527344 6.246094 33.011719 6.246094 C 33.011719 5.476562 33.011719 4.703125 33.011719 3.933594 C 34.527344 3.933594 36.042969 3.933594 37.5625 3.933594 C 37.5625 4.703125 37.5625 5.476562 37.5625 6.246094 Z M 37.5625 6.246094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(58.823529%,7.058824%,2.352941%)",
      fillOpacity: 1
    },
    d: "M 33.011719 6.246094 C 34.527344 6.246094 36.042969 6.246094 37.5625 6.246094 C 37.5625 6.988281 37.5625 7.726562 37.5625 8.46875 C 36.042969 8.46875 34.527344 8.46875 33.011719 8.46875 C 33.011719 7.726562 33.011719 6.988281 33.011719 6.246094 Z M 33.011719 6.246094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(58.039216%,7.058824%,2.352941%)",
      fillOpacity: 1
    },
    d: "M 33.011719 10.6875 C 34.527344 10.6875 36.042969 10.6875 37.5625 10.6875 C 37.5625 12.199219 37.5625 13.710938 37.5625 15.222656 C 36.042969 15.222656 34.527344 15.222656 33.011719 15.222656 C 33.011719 13.710938 33.011719 12.199219 33.011719 10.6875 Z M 33.011719 10.6875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,33.72549%,15.294118%)",
      fillOpacity: 1
    },
    d: "M 37.5625 19.757812 C 36.042969 19.757812 34.527344 19.757812 33.011719 19.757812 C 33.011719 18.988281 33.011719 18.214844 33.011719 17.445312 C 34.527344 17.445312 36.042969 17.445312 37.5625 17.445312 C 37.5625 18.214844 37.5625 18.988281 37.5625 19.757812 Z M 37.5625 19.757812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(58.039216%,72.941176%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 33.011719 19.757812 C 33.011719 21.269531 33.011719 22.78125 33.011719 24.292969 C 32.269531 24.292969 31.523438 24.292969 30.78125 24.292969 C 30.78125 22.78125 30.78125 21.269531 30.78125 19.757812 C 31.523438 19.757812 32.269531 19.757812 33.011719 19.757812 Z M 33.011719 19.757812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(1.568627%,44.705882%,18.431373%)",
      fillOpacity: 1
    },
    d: "M 33.011719 19.757812 C 34.527344 19.757812 36.042969 19.757812 37.5625 19.757812 C 37.5625 22.011719 37.5625 24.261719 37.5625 26.515625 C 37.5625 26.546875 37.5625 26.574219 37.5625 26.605469 C 37.5625 28.828125 37.5625 31.050781 37.5625 33.269531 C 35.300781 33.269531 33.042969 33.269531 30.78125 33.269531 C 30.78125 31.050781 30.78125 28.828125 30.78125 26.605469 C 30.039062 26.605469 29.296875 26.605469 28.554688 26.605469 C 28.582031 27.363281 28.554688 28.105469 28.460938 28.828125 C 28.460938 28.085938 28.460938 27.347656 28.460938 26.605469 C 27.71875 26.605469 26.976562 26.605469 26.230469 26.605469 C 26.230469 26.574219 26.230469 26.546875 26.230469 26.515625 C 26.976562 26.515625 27.71875 26.515625 28.460938 26.515625 C 29.234375 26.515625 30.007812 26.515625 30.78125 26.515625 C 31.523438 26.515625 32.269531 26.515625 33.011719 26.515625 C 33.011719 25.773438 33.011719 25.035156 33.011719 24.292969 C 33.011719 22.78125 33.011719 21.269531 33.011719 19.757812 Z M 33.011719 19.757812 "
  }), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface8",
    mask: "url(#mask1)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(58.039216%,72.54902%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 37.5625 19.757812 C 38.304688 19.757812 39.046875 19.757812 39.789062 19.757812 C 39.789062 21.269531 39.789062 22.78125 39.789062 24.292969 C 39.789062 25.035156 39.789062 25.773438 39.789062 26.515625 C 39.046875 26.515625 38.304688 26.515625 37.5625 26.515625 C 37.5625 24.261719 37.5625 22.011719 37.5625 19.757812 Z M 37.5625 19.757812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(57.647059%,72.156863%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 30.78125 24.292969 C 30.78125 25.035156 30.78125 25.773438 30.78125 26.515625 C 30.007812 26.515625 29.234375 26.515625 28.460938 26.515625 C 28.460938 25.773438 28.460938 25.035156 28.460938 24.292969 C 29.234375 24.292969 30.007812 24.292969 30.78125 24.292969 Z M 30.78125 24.292969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,34.901961%,15.294118%)",
      fillOpacity: 1
    },
    d: "M 30.78125 24.292969 C 31.523438 24.292969 32.269531 24.292969 33.011719 24.292969 C 33.011719 25.035156 33.011719 25.773438 33.011719 26.515625 C 32.269531 26.515625 31.523438 26.515625 30.78125 26.515625 C 30.78125 25.773438 30.78125 25.035156 30.78125 24.292969 Z M 30.78125 24.292969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(1.960784%,45.098039%,18.431373%)",
      fillOpacity: 1
    },
    d: "M 39.789062 24.292969 C 39.820312 24.292969 39.851562 24.292969 39.882812 24.292969 C 40.625 24.292969 41.367188 24.292969 42.109375 24.292969 C 42.109375 25.035156 42.109375 25.773438 42.109375 26.515625 C 41.335938 26.515625 40.5625 26.515625 39.789062 26.515625 C 39.789062 25.773438 39.789062 25.035156 39.789062 24.292969 Z M 39.789062 24.292969 "
  }), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface11",
    mask: "url(#mask2)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(57.647059%,72.54902%,12.941176%)",
      fillOpacity: 1
    },
    d: "M 26.230469 26.605469 C 26.976562 26.605469 27.71875 26.605469 28.460938 26.605469 C 28.460938 27.347656 28.460938 28.085938 28.460938 28.828125 C 27.71875 28.828125 26.976562 28.828125 26.230469 28.828125 C 26.230469 28.085938 26.230469 27.347656 26.230469 26.605469 Z M 26.230469 26.605469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,34.901961%,15.686275%)",
      fillOpacity: 1
    },
    d: "M 30.78125 33.269531 C 30.039062 33.269531 29.296875 33.269531 28.554688 33.269531 C 28.582031 32.511719 28.554688 31.773438 28.460938 31.050781 C 28.460938 30.308594 28.460938 29.566406 28.460938 28.828125 C 28.554688 28.105469 28.582031 27.363281 28.554688 26.605469 C 29.296875 26.605469 30.039062 26.605469 30.78125 26.605469 C 30.78125 28.828125 30.78125 31.050781 30.78125 33.269531 Z M 30.78125 33.269531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,34.901961%,15.686275%)",
      fillOpacity: 1
    },
    d: "M 37.5625 26.605469 C 38.304688 26.605469 39.046875 26.605469 39.789062 26.605469 C 39.789062 28.085938 39.789062 29.566406 39.789062 31.050781 C 39.789062 31.820312 39.789062 32.589844 39.789062 33.363281 C 36.769531 33.394531 33.769531 33.363281 30.78125 33.269531 C 33.042969 33.269531 35.300781 33.269531 37.5625 33.269531 C 37.5625 31.050781 37.5625 28.828125 37.5625 26.605469 Z M 37.5625 26.605469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(40.784314%,61.960784%,13.72549%)",
      fillOpacity: 1
    },
    d: "M 37.5625 26.605469 C 37.5625 26.574219 37.5625 26.546875 37.5625 26.515625 C 38.304688 26.515625 39.046875 26.515625 39.789062 26.515625 C 40.5625 26.515625 41.335938 26.515625 42.109375 26.515625 C 42.109375 26.546875 42.109375 26.574219 42.109375 26.605469 C 41.367188 26.605469 40.625 26.605469 39.882812 26.605469 C 39.882812 28.085938 39.882812 29.566406 39.882812 31.050781 C 39.851562 31.050781 39.820312 31.050781 39.789062 31.050781 C 39.789062 29.566406 39.789062 28.085938 39.789062 26.605469 C 39.046875 26.605469 38.304688 26.605469 37.5625 26.605469 Z M 37.5625 26.605469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(58.039216%,72.941176%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 42.109375 26.605469 C 42.109375 28.085938 42.109375 29.566406 42.109375 31.050781 C 41.367188 31.050781 40.625 31.050781 39.882812 31.050781 C 39.882812 29.566406 39.882812 28.085938 39.882812 26.605469 C 40.625 26.605469 41.367188 26.605469 42.109375 26.605469 Z M 42.109375 26.605469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(1.176471%,44.705882%,18.431373%)",
      fillOpacity: 1
    },
    d: "M 42.109375 26.515625 C 42.855469 26.515625 43.597656 26.515625 44.339844 26.515625 C 44.339844 28.027344 44.339844 29.539062 44.339844 31.050781 C 45.066406 31.140625 45.808594 31.171875 46.566406 31.140625 C 46.566406 43.171875 46.566406 55.203125 46.566406 67.234375 C 45.824219 67.234375 45.082031 67.234375 44.339844 67.234375 C 44.339844 63.46875 44.339844 59.707031 44.339844 55.945312 C 44.339844 49.898438 44.339844 43.851562 44.339844 37.804688 C 44.339844 36.324219 44.339844 34.84375 44.339844 33.363281 C 43.597656 33.363281 42.855469 33.363281 42.109375 33.363281 C 41.367188 33.363281 40.625 33.363281 39.882812 33.363281 C 39.882812 34.84375 39.882812 36.324219 39.882812 37.804688 C 39.851562 37.804688 39.820312 37.804688 39.789062 37.804688 C 39.789062 36.324219 39.789062 34.84375 39.789062 33.363281 C 39.789062 32.589844 39.789062 31.820312 39.789062 31.050781 C 39.820312 31.050781 39.851562 31.050781 39.882812 31.050781 C 40.625 31.050781 41.367188 31.050781 42.109375 31.050781 C 42.109375 29.566406 42.109375 28.085938 42.109375 26.605469 C 42.109375 26.574219 42.109375 26.546875 42.109375 26.515625 Z M 42.109375 26.515625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 23.910156 28.828125 C 23.910156 29.566406 23.910156 30.308594 23.910156 31.050781 C 19.390625 31.050781 14.871094 31.050781 10.355469 31.050781 C 10.355469 32.558594 10.355469 34.070312 10.355469 35.582031 C 9.609375 35.582031 8.867188 35.582031 8.125 35.582031 C 8.125 34.84375 8.125 34.101562 8.125 33.363281 C 7.382812 33.363281 6.640625 33.363281 5.894531 33.363281 C 5.894531 32.589844 5.894531 31.820312 5.894531 31.050781 C 6.640625 31.050781 7.382812 31.050781 8.125 31.050781 C 8.125 30.308594 8.125 29.566406 8.125 28.828125 C 13.386719 28.828125 18.648438 28.828125 23.910156 28.828125 Z M 23.910156 28.828125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(1.176471%,45.098039%,18.431373%)",
      fillOpacity: 1
    },
    d: "M 26.230469 28.828125 C 26.976562 28.828125 27.71875 28.828125 28.460938 28.828125 C 28.460938 29.566406 28.460938 30.308594 28.460938 31.050781 C 27.71875 31.050781 26.976562 31.050781 26.230469 31.050781 C 26.230469 30.308594 26.230469 29.566406 26.230469 28.828125 Z M 26.230469 28.828125 "
  }), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface14",
    mask: "url(#mask3)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(92.941176%,93.333333%,93.72549%)",
      fillOpacity: 1
    },
    d: "M 23.910156 28.828125 C 24.003906 29.550781 24.035156 30.292969 24.003906 31.050781 C 24.003906 31.078125 24.003906 31.109375 24.003906 31.140625 C 24.003906 31.882812 24.003906 32.621094 24.003906 33.363281 C 24.714844 33.363281 25.425781 33.363281 26.140625 33.363281 C 26.140625 34.84375 26.140625 36.324219 26.140625 37.804688 C 24.652344 37.804688 23.167969 37.804688 21.683594 37.804688 C 20.9375 37.804688 20.195312 37.804688 19.453125 37.804688 C 14.902344 37.804688 10.355469 37.804688 5.804688 37.804688 C 5.804688 35.550781 5.804688 33.300781 5.804688 31.050781 C 5.835938 31.050781 5.867188 31.050781 5.894531 31.050781 C 5.894531 31.820312 5.894531 32.589844 5.894531 33.363281 C 6.640625 33.363281 7.382812 33.363281 8.125 33.363281 C 8.125 34.101562 8.125 34.84375 8.125 35.582031 C 8.867188 35.582031 9.609375 35.582031 10.355469 35.582031 C 10.355469 34.070312 10.355469 32.558594 10.355469 31.050781 C 14.871094 31.050781 19.390625 31.050781 23.910156 31.050781 C 23.910156 30.308594 23.910156 29.566406 23.910156 28.828125 Z M 23.910156 28.828125 "
  }), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface17",
    mask: "url(#mask4)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 24.003906 31.140625 C 24.714844 31.140625 25.425781 31.140625 26.140625 31.140625 C 26.140625 31.882812 26.140625 32.621094 26.140625 33.363281 C 25.425781 33.363281 24.714844 33.363281 24.003906 33.363281 C 24.003906 32.621094 24.003906 31.882812 24.003906 31.140625 Z M 24.003906 31.140625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 26.230469 31.050781 C 26.976562 31.050781 27.71875 31.050781 28.460938 31.050781 C 28.460938 33.300781 28.460938 35.550781 28.460938 37.804688 C 27.71875 37.804688 26.976562 37.804688 26.230469 37.804688 C 26.230469 35.550781 26.230469 33.300781 26.230469 31.050781 Z M 26.230469 31.050781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0.392157%,31.764706%,13.333333%)",
      fillOpacity: 1
    },
    d: "M 44.339844 31.050781 C 45.113281 31.050781 45.886719 31.050781 46.660156 31.050781 C 46.691406 43.867188 46.660156 56.667969 46.566406 69.453125 C 46.566406 68.714844 46.566406 67.972656 46.566406 67.234375 C 46.566406 55.203125 46.566406 43.171875 46.566406 31.140625 C 45.808594 31.171875 45.066406 31.140625 44.339844 31.050781 Z M 44.339844 31.050781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(71.372549%,71.372549%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 24.003906 31.140625 C 24.003906 31.109375 24.003906 31.078125 24.003906 31.050781 C 24.746094 31.050781 25.488281 31.050781 26.230469 31.050781 C 26.230469 33.300781 26.230469 35.550781 26.230469 37.804688 C 26.203125 37.804688 26.171875 37.804688 26.140625 37.804688 C 26.140625 36.324219 26.140625 34.84375 26.140625 33.363281 C 26.140625 32.621094 26.140625 31.882812 26.140625 31.140625 C 25.425781 31.140625 24.714844 31.140625 24.003906 31.140625 Z M 24.003906 31.140625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,23.921569%,13.333333%)",
      fillOpacity: 1
    },
    d: "M 28.460938 31.050781 C 28.554688 31.773438 28.582031 32.511719 28.554688 33.269531 C 29.296875 33.269531 30.039062 33.269531 30.78125 33.269531 C 33.769531 33.363281 36.769531 33.394531 39.789062 33.363281 C 39.789062 34.84375 39.789062 36.324219 39.789062 37.804688 C 37.53125 37.804688 35.269531 37.804688 33.011719 37.804688 C 32.25 37.773438 31.507812 37.804688 30.78125 37.898438 C 30.039062 37.898438 29.296875 37.898438 28.554688 37.898438 C 28.554688 37.835938 28.523438 37.804688 28.460938 37.804688 C 28.460938 35.550781 28.460938 33.300781 28.460938 31.050781 Z M 28.460938 31.050781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(29.411765%,55.294118%,16.470588%)",
      fillOpacity: 1
    },
    d: "M 42.109375 33.363281 C 42.109375 34.84375 42.109375 36.324219 42.109375 37.804688 C 41.367188 37.804688 40.625 37.804688 39.882812 37.804688 C 39.882812 36.324219 39.882812 34.84375 39.882812 33.363281 C 40.625 33.363281 41.367188 33.363281 42.109375 33.363281 Z M 42.109375 33.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,24.313725%,13.333333%)",
      fillOpacity: 1
    },
    d: "M 42.109375 33.363281 C 42.855469 33.363281 43.597656 33.363281 44.339844 33.363281 C 44.339844 34.84375 44.339844 36.324219 44.339844 37.804688 C 43.597656 37.804688 42.855469 37.804688 42.109375 37.804688 C 42.109375 36.324219 42.109375 34.84375 42.109375 33.363281 Z M 42.109375 33.363281 "
  }), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface20",
    mask: "url(#mask5)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(27.45098%,27.45098%,27.843137%)",
      fillOpacity: 1
    },
    d: "M 3.480469 37.804688 C 4.257812 37.804688 5.03125 37.804688 5.804688 37.804688 C 5.804688 37.835938 5.804688 37.867188 5.804688 37.898438 C 5.0625 37.898438 4.316406 37.898438 3.574219 37.898438 C 3.574219 40.890625 3.574219 43.882812 3.574219 46.875 C 3.574219 47.613281 3.574219 48.355469 3.574219 49.09375 C 4.316406 49.09375 5.0625 49.09375 5.804688 49.09375 C 5.804688 49.125 5.804688 49.15625 5.804688 49.1875 C 5.03125 49.1875 4.257812 49.1875 3.480469 49.1875 C 3.480469 45.394531 3.480469 41.597656 3.480469 37.804688 Z M 3.480469 37.804688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(92.941176%,93.72549%,93.72549%)",
      fillOpacity: 1
    },
    d: "M 5.804688 37.898438 C 5.804688 40.890625 5.804688 43.882812 5.804688 46.875 C 5.0625 46.875 4.316406 46.875 3.574219 46.875 C 3.574219 43.882812 3.574219 40.890625 3.574219 37.898438 C 4.316406 37.898438 5.0625 37.898438 5.804688 37.898438 Z M 5.804688 37.898438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(90.588235%,38.431373%,36.078431%)",
      fillOpacity: 1
    },
    d: "M 5.804688 37.804688 C 10.355469 37.804688 14.902344 37.804688 19.453125 37.804688 C 16.4375 37.898438 13.402344 37.929688 10.355469 37.898438 C 10.355469 39.378906 10.355469 40.859375 10.355469 42.339844 C 9.609375 42.339844 8.867188 42.339844 8.125 42.339844 C 8.125 40.859375 8.125 39.378906 8.125 37.898438 C 7.382812 37.898438 6.640625 37.898438 5.894531 37.898438 C 5.894531 39.378906 5.894531 40.859375 5.894531 42.339844 C 5.894531 43.109375 5.894531 43.882812 5.894531 44.652344 C 5.894531 45.394531 5.894531 46.132812 5.894531 46.875 C 5.867188 46.875 5.835938 46.875 5.804688 46.875 C 5.804688 43.882812 5.804688 40.890625 5.804688 37.898438 C 5.804688 37.867188 5.804688 37.835938 5.804688 37.804688 Z M 5.804688 37.804688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(75.294118%,4.313725%,14.901961%)",
      fillOpacity: 1
    },
    d: "M 8.125 42.339844 C 7.382812 42.339844 6.640625 42.339844 5.894531 42.339844 C 5.894531 40.859375 5.894531 39.378906 5.894531 37.898438 C 6.640625 37.898438 7.382812 37.898438 8.125 37.898438 C 8.125 39.378906 8.125 40.859375 8.125 42.339844 Z M 8.125 42.339844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(75.294118%,3.921569%,14.901961%)",
      fillOpacity: 1
    },
    d: "M 19.453125 37.804688 C 20.195312 37.804688 20.9375 37.804688 21.683594 37.804688 C 23.152344 37.898438 24.636719 37.925781 26.140625 37.898438 C 26.140625 38.605469 26.140625 39.316406 26.140625 40.027344 C 25.425781 40.027344 24.714844 40.027344 24.003906 40.027344 C 24.003906 40.796875 24.003906 41.566406 24.003906 42.339844 C 23.230469 42.339844 22.457031 42.339844 21.683594 42.339844 C 21.683594 43.078125 21.683594 43.820312 21.683594 44.558594 C 17.164062 44.558594 12.644531 44.558594 8.125 44.558594 C 8.125 43.820312 8.125 43.078125 8.125 42.339844 C 8.867188 42.339844 9.609375 42.339844 10.355469 42.339844 C 10.355469 40.859375 10.355469 39.378906 10.355469 37.898438 C 13.402344 37.929688 16.4375 37.898438 19.453125 37.804688 Z M 19.453125 37.804688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(92.941176%,93.333333%,93.72549%)",
      fillOpacity: 1
    },
    d: "M 26.230469 37.804688 C 26.976562 37.804688 27.71875 37.804688 28.460938 37.804688 C 28.460938 40.828125 28.460938 43.851562 28.460938 46.875 C 27.71875 46.875 26.976562 46.875 26.230469 46.875 C 26.230469 46.101562 26.230469 45.332031 26.230469 44.558594 C 26.230469 42.308594 26.230469 40.054688 26.230469 37.804688 Z M 26.230469 37.804688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 28.554688 37.898438 C 29.296875 37.898438 30.039062 37.898438 30.78125 37.898438 C 30.78125 40.890625 30.78125 43.882812 30.78125 46.875 C 30.691406 47.597656 30.660156 48.335938 30.6875 49.09375 C 29.976562 49.09375 29.265625 49.09375 28.554688 49.09375 C 28.554688 45.363281 28.554688 41.628906 28.554688 37.898438 Z M 28.554688 37.898438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,94.901961%,83.921569%)",
      fillOpacity: 1
    },
    d: "M 33.011719 37.804688 C 35.253906 37.898438 37.515625 37.929688 39.789062 37.898438 C 39.789062 43.882812 39.789062 49.867188 39.789062 55.851562 C 36.785156 55.851562 33.785156 55.851562 30.78125 55.851562 C 30.78125 53.628906 30.78125 51.410156 30.78125 49.1875 C 30.78125 48.417969 30.78125 47.644531 30.78125 46.875 C 30.78125 43.882812 30.78125 40.890625 30.78125 37.898438 C 31.507812 37.804688 32.25 37.773438 33.011719 37.804688 Z M 33.011719 37.804688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,96.862745%,91.372549%)",
      fillOpacity: 1
    },
    d: "M 39.789062 37.898438 C 40.5625 37.898438 41.335938 37.898438 42.109375 37.898438 C 42.109375 43.882812 42.109375 49.867188 42.109375 55.851562 C 41.335938 55.851562 40.5625 55.851562 39.789062 55.851562 C 39.789062 49.867188 39.789062 43.882812 39.789062 37.898438 Z M 39.789062 37.898438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(93.72549%,86.666667%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 33.011719 37.804688 C 35.269531 37.804688 37.53125 37.804688 39.789062 37.804688 C 39.820312 37.804688 39.851562 37.804688 39.882812 37.804688 C 40.625 37.804688 41.367188 37.804688 42.109375 37.804688 C 42.855469 37.804688 43.597656 37.804688 44.339844 37.804688 C 44.339844 43.851562 44.339844 49.898438 44.339844 55.945312 C 43.597656 55.945312 42.855469 55.945312 42.109375 55.945312 C 41.367188 55.945312 40.625 55.945312 39.882812 55.945312 C 39.851562 55.945312 39.820312 55.945312 39.789062 55.945312 C 36.011719 55.945312 32.238281 55.945312 28.460938 55.945312 C 27.71875 55.945312 26.976562 55.945312 26.230469 55.945312 C 26.230469 55.914062 26.230469 55.882812 26.230469 55.851562 C 27.75 55.851562 29.265625 55.851562 30.78125 55.851562 C 33.785156 55.851562 36.785156 55.851562 39.789062 55.851562 C 40.5625 55.851562 41.335938 55.851562 42.109375 55.851562 C 42.109375 49.867188 42.109375 43.882812 42.109375 37.898438 C 41.335938 37.898438 40.5625 37.898438 39.789062 37.898438 C 37.515625 37.929688 35.253906 37.898438 33.011719 37.804688 Z M 33.011719 37.804688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(68.235294%,4.705882%,10.980392%)",
      fillOpacity: 1
    },
    d: "M 26.140625 40.027344 C 26.140625 40.796875 26.140625 41.566406 26.140625 42.339844 C 25.425781 42.339844 24.714844 42.339844 24.003906 42.339844 C 24.003906 41.566406 24.003906 40.796875 24.003906 40.027344 C 24.714844 40.027344 25.425781 40.027344 26.140625 40.027344 Z M 26.140625 40.027344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(76.862745%,33.72549%,38.431373%)",
      fillOpacity: 1
    },
    d: "M 21.683594 37.804688 C 23.167969 37.804688 24.652344 37.804688 26.140625 37.804688 C 26.171875 37.804688 26.203125 37.804688 26.230469 37.804688 C 26.230469 40.054688 26.230469 42.308594 26.230469 44.558594 C 26.140625 43.835938 26.109375 43.097656 26.140625 42.339844 C 26.140625 41.566406 26.140625 40.796875 26.140625 40.027344 C 26.140625 39.316406 26.140625 38.605469 26.140625 37.898438 C 24.636719 37.925781 23.152344 37.898438 21.683594 37.804688 Z M 21.683594 37.804688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(58.039216%,5.098039%,9.803922%)",
      fillOpacity: 1
    },
    d: "M 24.003906 42.339844 C 24.714844 42.339844 25.425781 42.339844 26.140625 42.339844 C 26.109375 43.097656 26.140625 43.835938 26.230469 44.558594 C 26.230469 45.332031 26.230469 46.101562 26.230469 46.875 C 25.488281 46.875 24.746094 46.875 24.003906 46.875 C 23.910156 47.597656 23.878906 48.335938 23.910156 49.09375 C 18.648438 49.09375 13.386719 49.09375 8.125 49.09375 C 8.125 48.355469 8.125 47.613281 8.125 46.875 C 12.644531 46.875 17.164062 46.875 21.683594 46.875 C 21.683594 46.101562 21.683594 45.332031 21.683594 44.558594 C 22.457031 44.558594 23.230469 44.558594 24.003906 44.558594 C 24.003906 43.820312 24.003906 43.078125 24.003906 42.339844 Z M 24.003906 42.339844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(68.235294%,4.705882%,10.980392%)",
      fillOpacity: 1
    },
    d: "M 24.003906 42.339844 C 24.003906 43.078125 24.003906 43.820312 24.003906 44.558594 C 23.230469 44.558594 22.457031 44.558594 21.683594 44.558594 C 21.683594 43.820312 21.683594 43.078125 21.683594 42.339844 C 22.457031 42.339844 23.230469 42.339844 24.003906 42.339844 Z M 24.003906 42.339844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(58.039216%,5.098039%,9.803922%)",
      fillOpacity: 1
    },
    d: "M 5.894531 44.652344 C 6.640625 44.652344 7.382812 44.652344 8.125 44.652344 C 8.125 45.394531 8.125 46.132812 8.125 46.875 C 8.09375 46.875 8.0625 46.875 8.03125 46.875 C 7.320312 46.875 6.609375 46.875 5.894531 46.875 C 5.894531 46.132812 5.894531 45.394531 5.894531 44.652344 Z M 5.894531 44.652344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(68.235294%,4.705882%,10.980392%)",
      fillOpacity: 1
    },
    d: "M 5.894531 42.339844 C 6.640625 42.339844 7.382812 42.339844 8.125 42.339844 C 8.125 43.078125 8.125 43.820312 8.125 44.558594 C 12.644531 44.558594 17.164062 44.558594 21.683594 44.558594 C 21.683594 45.332031 21.683594 46.101562 21.683594 46.875 C 17.164062 46.875 12.644531 46.875 8.125 46.875 C 8.125 46.132812 8.125 45.394531 8.125 44.652344 C 7.382812 44.652344 6.640625 44.652344 5.894531 44.652344 C 5.894531 43.882812 5.894531 43.109375 5.894531 42.339844 Z M 5.894531 42.339844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(80.784314%,81.568627%,81.960784%)",
      fillOpacity: 1
    },
    d: "M 3.574219 46.875 C 4.316406 46.875 5.0625 46.875 5.804688 46.875 C 5.804688 47.613281 5.804688 48.355469 5.804688 49.09375 C 5.0625 49.09375 4.316406 49.09375 3.574219 49.09375 C 3.574219 48.355469 3.574219 47.613281 3.574219 46.875 Z M 3.574219 46.875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(92.941176%,93.333333%,93.72549%)",
      fillOpacity: 1
    },
    d: "M 5.804688 46.875 C 5.835938 46.875 5.867188 46.875 5.894531 46.875 C 6.609375 46.875 7.320312 46.875 8.03125 46.875 C 8.03125 47.613281 8.03125 48.355469 8.03125 49.09375 C 7.289062 49.09375 6.546875 49.09375 5.804688 49.09375 C 5.804688 48.355469 5.804688 47.613281 5.804688 46.875 Z M 5.804688 46.875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(92.941176%,93.333333%,93.72549%)",
      fillOpacity: 1
    },
    d: "M 24.003906 46.875 C 24.746094 46.875 25.488281 46.875 26.230469 46.875 C 26.230469 47.613281 26.230469 48.355469 26.230469 49.09375 C 25.488281 49.09375 24.746094 49.09375 24.003906 49.09375 C 24.003906 48.355469 24.003906 47.613281 24.003906 46.875 Z M 24.003906 46.875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(80.784314%,81.568627%,81.960784%)",
      fillOpacity: 1
    },
    d: "M 26.230469 46.875 C 26.976562 46.875 27.71875 46.875 28.460938 46.875 C 28.460938 47.613281 28.460938 48.355469 28.460938 49.09375 C 27.71875 49.09375 26.976562 49.09375 26.230469 49.09375 C 26.230469 48.355469 26.230469 47.613281 26.230469 46.875 Z M 26.230469 46.875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(34.509804%,33.333333%,30.980392%)",
      fillOpacity: 1
    },
    d: "M 28.460938 37.804688 C 28.523438 37.804688 28.554688 37.835938 28.554688 37.898438 C 28.554688 41.628906 28.554688 45.363281 28.554688 49.09375 C 29.265625 49.09375 29.976562 49.09375 30.6875 49.09375 C 30.660156 48.335938 30.691406 47.597656 30.78125 46.875 C 30.78125 47.644531 30.78125 48.417969 30.78125 49.1875 C 30.039062 49.1875 29.296875 49.1875 28.554688 49.1875 C 28.554688 49.929688 28.554688 50.667969 28.554688 51.410156 C 27.78125 51.410156 27.007812 51.410156 26.230469 51.410156 C 26.230469 51.378906 26.230469 51.347656 26.230469 51.316406 C 26.976562 51.316406 27.71875 51.316406 28.460938 51.316406 C 28.460938 50.605469 28.460938 49.898438 28.460938 49.1875 C 27.71875 49.1875 26.976562 49.1875 26.230469 49.1875 C 26.230469 49.15625 26.230469 49.125 26.230469 49.09375 C 26.976562 49.09375 27.71875 49.09375 28.460938 49.09375 C 28.460938 48.355469 28.460938 47.613281 28.460938 46.875 C 28.460938 43.851562 28.460938 40.828125 28.460938 37.804688 Z M 28.460938 37.804688 "
  }), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface23",
    mask: "url(#mask6)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(80.784314%,80%,80.784314%)",
      fillOpacity: 1
    },
    d: "M 8.03125 46.875 C 8.0625 46.875 8.09375 46.875 8.125 46.875 C 8.125 47.613281 8.125 48.355469 8.125 49.09375 C 13.386719 49.09375 18.648438 49.09375 23.910156 49.09375 C 23.878906 48.335938 23.910156 47.597656 24.003906 46.875 C 24.003906 47.613281 24.003906 48.355469 24.003906 49.09375 C 24.746094 49.09375 25.488281 49.09375 26.230469 49.09375 C 26.230469 49.125 26.230469 49.15625 26.230469 49.1875 C 26.140625 49.878906 26.109375 50.589844 26.140625 51.316406 C 23.152344 51.285156 20.179688 51.316406 17.226562 51.410156 C 17.195312 51.410156 17.164062 51.410156 17.132812 51.410156 C 16.390625 51.410156 15.644531 51.410156 14.902344 51.410156 C 11.917969 51.316406 8.914062 51.285156 5.894531 51.316406 C 5.925781 50.589844 5.894531 49.878906 5.804688 49.1875 C 5.804688 49.15625 5.804688 49.125 5.804688 49.09375 C 6.546875 49.09375 7.289062 49.09375 8.03125 49.09375 C 8.03125 48.355469 8.03125 47.613281 8.03125 46.875 Z M 8.03125 46.875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 26.230469 49.1875 C 26.976562 49.1875 27.71875 49.1875 28.460938 49.1875 C 28.460938 49.898438 28.460938 50.605469 28.460938 51.316406 C 27.71875 51.316406 26.976562 51.316406 26.230469 51.316406 C 26.230469 50.605469 26.230469 49.898438 26.230469 49.1875 Z M 26.230469 49.1875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(96.078431%,87.843137%,72.941176%)",
      fillOpacity: 1
    },
    d: "M 30.78125 49.1875 C 30.78125 51.410156 30.78125 53.628906 30.78125 55.851562 C 29.265625 55.851562 27.75 55.851562 26.230469 55.851562 C 26.230469 54.371094 26.230469 52.890625 26.230469 51.410156 C 27.007812 51.410156 27.78125 51.410156 28.554688 51.410156 C 28.554688 50.667969 28.554688 49.929688 28.554688 49.1875 C 29.296875 49.1875 30.039062 49.1875 30.78125 49.1875 Z M 30.78125 49.1875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(60.392157%,60.784314%,61.568627%)",
      fillOpacity: 1
    },
    d: "M 5.804688 49.1875 C 5.894531 49.878906 5.925781 50.589844 5.894531 51.316406 C 8.914062 51.285156 11.917969 51.316406 14.902344 51.410156 C 11.871094 51.410156 8.835938 51.410156 5.804688 51.410156 C 5.804688 50.667969 5.804688 49.929688 5.804688 49.1875 Z M 5.804688 49.1875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(60.392157%,60.784314%,61.568627%)",
      fillOpacity: 1
    },
    d: "M 26.230469 49.1875 C 26.230469 49.898438 26.230469 50.605469 26.230469 51.316406 C 26.230469 51.347656 26.230469 51.378906 26.230469 51.410156 C 23.230469 51.410156 20.226562 51.410156 17.226562 51.410156 C 20.179688 51.316406 23.152344 51.285156 26.140625 51.316406 C 26.109375 50.589844 26.140625 49.878906 26.230469 49.1875 Z M 26.230469 49.1875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(70.980392%,72.156863%,72.156863%)",
      fillOpacity: 1
    },
    d: "M 14.902344 51.410156 C 15.644531 51.410156 16.390625 51.410156 17.132812 51.410156 C 17.132812 52.148438 17.132812 52.890625 17.132812 53.628906 C 16.390625 53.628906 15.644531 53.628906 14.902344 53.628906 C 14.902344 52.890625 14.902344 52.148438 14.902344 51.410156 Z M 14.902344 51.410156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(92.941176%,93.333333%,93.72549%)",
      fillOpacity: 1
    },
    d: "M 14.902344 53.628906 C 15.644531 53.628906 16.390625 53.628906 17.132812 53.628906 C 17.132812 55.914062 17.132812 58.195312 17.132812 60.476562 C 16.390625 60.476562 15.644531 60.476562 14.902344 60.476562 C 14.902344 58.195312 14.902344 55.914062 14.902344 53.628906 Z M 14.902344 53.628906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,34.901961%,15.294118%)",
      fillOpacity: 1
    },
    d: "M 26.230469 55.945312 C 26.976562 55.945312 27.71875 55.945312 28.460938 55.945312 C 28.460938 59.707031 28.460938 63.46875 28.460938 67.234375 C 32.238281 67.234375 36.011719 67.234375 39.789062 67.234375 C 40.5625 67.234375 41.335938 67.234375 42.109375 67.234375 C 42.855469 67.234375 43.597656 67.234375 44.339844 67.234375 C 45.082031 67.234375 45.824219 67.234375 46.566406 67.234375 C 46.566406 67.972656 46.566406 68.714844 46.566406 69.453125 C 39.789062 69.453125 33.011719 69.453125 26.230469 69.453125 C 26.230469 64.949219 26.230469 60.449219 26.230469 55.945312 Z M 26.230469 55.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,24.313725%,13.72549%)",
      fillOpacity: 1
    },
    d: "M 28.460938 55.945312 C 32.238281 55.945312 36.011719 55.945312 39.789062 55.945312 C 39.789062 59.707031 39.789062 63.46875 39.789062 67.234375 C 36.011719 67.234375 32.238281 67.234375 28.460938 67.234375 C 28.460938 63.46875 28.460938 59.707031 28.460938 55.945312 Z M 28.460938 55.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(29.411765%,55.294118%,16.470588%)",
      fillOpacity: 1
    },
    d: "M 39.882812 55.945312 C 40.625 55.945312 41.367188 55.945312 42.109375 55.945312 C 42.109375 59.675781 42.109375 63.410156 42.109375 67.140625 C 41.367188 67.140625 40.625 67.140625 39.882812 67.140625 C 39.882812 63.410156 39.882812 59.675781 39.882812 55.945312 Z M 39.882812 55.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,24.313725%,13.72549%)",
      fillOpacity: 1
    },
    d: "M 42.109375 55.945312 C 42.855469 55.945312 43.597656 55.945312 44.339844 55.945312 C 44.339844 59.707031 44.339844 63.46875 44.339844 67.234375 C 43.597656 67.234375 42.855469 67.234375 42.109375 67.234375 C 42.109375 67.203125 42.109375 67.171875 42.109375 67.140625 C 42.109375 63.410156 42.109375 59.675781 42.109375 55.945312 Z M 42.109375 55.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(22.352941%,22.352941%,22.745098%)",
      fillOpacity: 1
    },
    d: "M 17.132812 51.410156 C 17.164062 51.410156 17.195312 51.410156 17.226562 51.410156 C 17.226562 56.652344 17.226562 61.898438 17.226562 67.140625 C 19.5 67.109375 21.761719 67.140625 24.003906 67.234375 C 23.230469 67.234375 22.457031 67.234375 21.683594 67.234375 C 20.9375 67.234375 20.195312 67.234375 19.453125 67.234375 C 18.679688 67.234375 17.90625 67.234375 17.132812 67.234375 C 17.132812 64.980469 17.132812 62.730469 17.132812 60.476562 C 17.132812 58.195312 17.132812 55.914062 17.132812 53.628906 C 17.132812 52.890625 17.132812 52.148438 17.132812 51.410156 Z M 17.132812 51.410156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(81.176471%,81.568627%,82.352941%)",
      fillOpacity: 1
    },
    d: "M 14.902344 60.476562 C 15.644531 60.476562 16.390625 60.476562 17.132812 60.476562 C 17.132812 62.730469 17.132812 64.980469 17.132812 67.234375 C 16.390625 67.234375 15.644531 67.234375 14.902344 67.234375 C 14.902344 64.980469 14.902344 62.730469 14.902344 60.476562 Z M 14.902344 60.476562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(20.784314%,46.27451%,15.686275%)",
      fillOpacity: 1
    },
    d: "M 39.789062 55.945312 C 39.820312 55.945312 39.851562 55.945312 39.882812 55.945312 C 39.882812 59.675781 39.882812 63.410156 39.882812 67.140625 C 40.625 67.140625 41.367188 67.140625 42.109375 67.140625 C 42.109375 67.171875 42.109375 67.203125 42.109375 67.234375 C 41.335938 67.234375 40.5625 67.234375 39.789062 67.234375 C 39.789062 63.46875 39.789062 59.707031 39.789062 55.945312 Z M 39.789062 55.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(92.941176%,93.72549%,93.72549%)",
      fillOpacity: 1
    },
    d: "M 10.355469 67.234375 C 10.355469 67.972656 10.355469 68.714844 10.355469 69.453125 C 9.609375 69.453125 8.867188 69.453125 8.125 69.453125 C 8.125 68.714844 8.125 67.972656 8.125 67.234375 C 8.867188 67.234375 9.609375 67.234375 10.355469 67.234375 Z M 10.355469 67.234375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 10.355469 67.234375 C 11.128906 67.234375 11.902344 67.234375 12.675781 67.234375 C 12.675781 67.972656 12.675781 68.714844 12.675781 69.453125 C 11.902344 69.453125 11.128906 69.453125 10.355469 69.453125 C 10.355469 68.714844 10.355469 67.972656 10.355469 67.234375 Z M 10.355469 67.234375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(92.941176%,93.72549%,93.72549%)",
      fillOpacity: 1
    },
    d: "M 12.675781 67.234375 C 13.417969 67.234375 14.160156 67.234375 14.902344 67.234375 C 15.644531 67.234375 16.390625 67.234375 17.132812 67.234375 C 17.90625 67.234375 18.679688 67.234375 19.453125 67.234375 C 19.453125 67.972656 19.453125 68.714844 19.453125 69.453125 C 17.195312 69.453125 14.933594 69.453125 12.675781 69.453125 C 12.675781 68.714844 12.675781 67.972656 12.675781 67.234375 Z M 12.675781 67.234375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(80.784314%,81.568627%,81.960784%)",
      fillOpacity: 1
    },
    d: "M 19.453125 67.234375 C 20.195312 67.234375 20.9375 67.234375 21.683594 67.234375 C 21.683594 67.972656 21.683594 68.714844 21.683594 69.453125 C 20.9375 69.453125 20.195312 69.453125 19.453125 69.453125 C 19.453125 68.714844 19.453125 67.972656 19.453125 67.234375 Z M 19.453125 67.234375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(92.156863%,92.54902%,92.941176%)",
      fillOpacity: 1
    },
    d: "M 21.683594 67.234375 C 22.457031 67.234375 23.230469 67.234375 24.003906 67.234375 C 24.003906 67.972656 24.003906 68.714844 24.003906 69.453125 C 23.230469 69.453125 22.457031 69.453125 21.683594 69.453125 C 21.683594 68.714844 21.683594 67.972656 21.683594 67.234375 Z M 21.683594 67.234375 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWine);
export default __webpack_public_path__ + "static/media/wine.3e6ea36ffed68bbb0a45b7c1b2b613bd.svg";
export { ForwardRef as ReactComponent };